module.exports = __webpack_public_path__ + "img/logo-deco3.7046f738.png";